import {useField} from "formik"
import React from "react"
import {useTranslation} from 'react-i18next';

export default () => {
  const {t} = useTranslation();
  const [field, meta] = useField('phone');
  const [fieldDialcode, metaDialcode] = useField('dial_code');
  const [isFocus, setFocus] = React.useState(false);

  function toggleFocus(e) {
    if (isFocus) field.onBlur(e);
    setFocus(!isFocus);
  }
  return (
    <div className={`formGroup${((meta.touched && meta.error) || (metaDialcode.touched && metaDialcode.error)) ? ' error' : ''}`}>
      <div className="fieldGroup">
        <div className="formField" style={{flexBasis: '25%'}} >
          <span style={{position: 'absolute', top: '13px', left: '13px', color: '#888'}}>+</span><input type="text" {...fieldDialcode} style={{paddingLeft: 30}} />
        </div>
        <div className="formField" style={{flexBasis: '75%'}}>
          <label className={`fieldLabel${(field.value||isFocus) ? ' touched' : ''}`}>{t('Telefono')}</label>
          <input type="text" {...field} onFocus={toggleFocus} onBlur={toggleFocus} />
        </div>
      </div>
      {meta.touched && meta.error && <div className="errorMessage">{meta.error}</div>}
      {metaDialcode.touched && metaDialcode.error && <div className="errorMessage">{metaDialcode.error}</div>}
    </div>
  )
}

